{
  "$id": "http://softball.app/schemas/optimization-read-only",
  "title": "Optimization - Read Only",
  "type": "object",
  "properties": {
    "status": {
      "type": "integer",
      "description": "Indicates what state the optimization is currently in e.g. NOT_STARTED, IN_PROGRESS, COMPLETE etc."
    },
    "pause": {
      "type": "boolean",
      "description": "Whether the user has requested that the optimization be paused or not"
    }
  }
}
